// SPDX-License-Identifier: LicenseRef-VicZhuProprietary
// SPDX-FileCopyrightText: 2026 Vic Zhu <viczhu2014@gmail.com>

/**
 * Shared pet-share types — single source of truth for the share record
 * shape. Previously MySharedPets and SharedWithMe each declared their own
 * `VetShare` interface, so model changes had to land twice (and could
 * silently diverge).
 */

export interface SharedPet {
  id: string | number
  name: string
  species?: string
  owner?: {
    name: string
    email: string
  }
}

export interface VetShare {
  id: string | number
  shareType: 'all_pets' | 'specific_pets'
  inviteStatus: 'active' | 'pending' | 'accepted' | 'declined'
  status: 'active' | 'revoked' | 'expired'
  /** Outgoing shares: the receiving vet (absent on pending email invites) */
  recipient?: {
    id: string | number
    name: string
    email: string
  }
  /** Incoming shares: the vet who shared */
  sharer?: {
    id: string | number
    name: string
    email: string
  }
  recipientEmail?: string
  /** Present on the sharer's own pending invites (my-shares) — used for copy-link */
  inviteToken?: string
  sharedPets?: SharedPet[]
  permissions: string[]
  note?: string
  createdAt: string
  expiresAt?: string
}

export const ALL_PERMISSIONS = [
  'view_metrics',
  'view_emrs',
  'add_activities',
  'add_emr_notes',
] as const

export const PERMISSION_LABELS: Record<string, string> = {
  view_metrics: 'View Metrics',
  view_emrs: 'View EMRs',
  add_activities: 'Add Activities',
  add_emr_notes: 'Add Notes',
}
